import { InjectionToken } from '@angular/core';
import { LocalCache } from '@nk/caching-lib';
import { CustomerPersonCompositeEntity, CustomerPersonEntity } from '@nk/data-entities-lib';
import { Observable } from 'rxjs';

export interface CustomerPersonApiService {
  customerPersonCache: LocalCache<
    CustomerPersonApiService,
    (screeningConfigUuid: string, customerPersonUuid: string) => Observable<CustomerPersonEntity>
  >;
  customerPersonCompositeCache: LocalCache<
    CustomerPersonApiService,
    (screeningConfigUuid: string, customerPersonUuid: string) => Observable<CustomerPersonCompositeEntity>
  >;
}
export const CUSTOMER_PERSON_API_SERVICE_TOKEN = new InjectionToken<CustomerPersonApiService>(
  'CustomerPersonApiService',
);
